import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Cloud Rhino. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
